import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button as MuiButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import ProductDetail from "./ProductDetail";
import heartLoading from "../../../assests/heartLoading.gif";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(0),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    maxWidth: "90vw",
    width: "100%",
    maxHeight: "90vh",
  },
}));

export default function ProductDetailModal({
  isOpen,
  onClose,
  productData,
  loading,
}) {
  return (
    <BootstrapDialog
      onClose={onClose}
      aria-labelledby="product-detail-dialog-title"
      open={isOpen}
      fullWidth
      maxWidth="lg"
      minHeight="80vh"
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          fontSize: "18px",
          fontWeight: "bold",
          color: "#bb1ccc",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        id="product-detail-dialog-title"
      >
        Product Details
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ maxHeight: "75vh", overflowY: "auto" }}>
        {loading ? (
          <div className="flex flex-col items-center justify-center py-12">
            <img src={heartLoading} alt="Loading..." className="h-30" />
            <span className="text-gray-700 text-[20px] mt-4">
              Loading product details...
            </span>
          </div>
        ) : productData ? (
          <ProductDetail product={productData} />
        ) : (
          <div className="flex flex-col items-center justify-center py-12">
            <span className="text-gray-700 text-[20px]">
              No product data available
            </span>
          </div>
        )}
      </DialogContent>

      <DialogActions>
        <MuiButton
          onClick={onClose}
          sx={{ borderColor: "#bb1ccc", color: "#bb1ccc" }}
          variant="outlined"
        >
          Close
        </MuiButton>
      </DialogActions>
    </BootstrapDialog>
  );
}

